
import { Component, Mixins } from "vue-property-decorator";
import { IRollSelectBehavior } from "../../../../../../documaker/domain/format/objects";
import { IRollSelectBehaviorPropertyEditable, instanceOfIRollSelectBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class RollSelectBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IRollSelectBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IRollSelectBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isRollSelectBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIRollSelectBehaviorPropertyEditable(s) && s.rollSelectBehavior().isEditable(), false);
  }

  get rollSelectBehavior(): IRollSelectBehavior {
    return this.readPropertyOrDefault(s => s.rollSelectBehavior().getValue(), { options: [] });
  }

  set rollSelectBehavior(value: IRollSelectBehavior) {
    this.writePropertyWhenValid(s => s.rollSelectBehavior().setValue(value));
  }
}
